
export default class EnvHelper {
    public static isDevelopmentQa = () : boolean => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'FARM';
        } else if (ENV_NAME === 'qa') {
            return 'FARM QA';
        } else if (ENV_NAME === 'dev') {
            return 'FARM DEV';
        } else {
            return 'FARM ENV NOT FOUND';
        }
    };
}